/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Credittopupkeep3Inputs */

const en_credittopupkeep3 = /** @type {(inputs: Credittopupkeep3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bought credits never expire and stay when your monthly credits are topped up.`)
};

const de_credittopupkeep3 = /** @type {(inputs: Credittopupkeep3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gekaufte Credits verfallen nicht und bleiben beim monatlichen Auffüllen erhalten.`)
};

/**
* | output |
* | --- |
* | "Bought credits never expire and stay when your monthly credits are topped up." |
*
* @param {Credittopupkeep3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const credittopupkeep3 = /** @type {((inputs?: Credittopupkeep3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Credittopupkeep3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_credittopupkeep3(inputs)
	return de_credittopupkeep3(inputs)
});
export { credittopupkeep3 as "creditTopUpKeep" }